import { useCallback, useState } from "react";


const useKeyboardInputRef = () => {
  const [keyboardOpen, setKeyboardOpen] = useState(false);
  const [height, setHeight] = useState(window.innerHeight);

  const onInputFocus = useCallback(() => {
    const newHeight = window.innerHeight;
    setHeight(newHeight);
    setKeyboardOpen(true);
  }, []);

  const onInputBlur = useCallback(() => {
    setHeight(window.innerHeight);
    setKeyboardOpen(false);
  }, []);

  return { keyboardOpen, height, onInputFocus, onInputBlur };
};

export default useKeyboardInputRef;